import { inject, Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { filter, take, map } from 'rxjs/operators';
import { EnvironmentService } from './environment.service';
import { BaseSiteService } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class GoogleSearchConsoleService {
  private environmentService = inject(EnvironmentService);
  private meta = inject(Meta);
  private baseSiteService = inject(BaseSiteService);

  addVerificationMetaTag() {
    this.baseSiteService
      .getActive()
      .pipe(
        take(1),
        map((active) => this.environmentService.getCurrentEnvironment().googleSearchConsole[active]),
        filter((value) => Boolean(value))
      )
      .subscribe((googleSearchConsole) => {
        this.meta.addTag({ name: 'google-site-verification', content: googleSearchConsole });
      });
  }
}
